import { memo } from 'react';

import Conversion from 'bloko/blocks/conversion';
import CustomSelect, { CustomSelectOption } from 'bloko/blocks/customSelect';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { format } from 'bloko/common/trl';

import translation from 'src/components/translation';

const TrlKeys = {
    empty: 'price.tariffField.optionsCount.empty',
    one: 'price.tariffField.optionsCount.one',
    some: 'price.tariffField.optionsCount.some',
    many: 'price.tariffField.optionsCount.many',
};

const customSelectWrapperProps = { 'data-qa': 'tariff-field-civCount' };

const TariffFieldOptionsCount: TranslatedComponent<{
    values: string[];
    value?: string;
    onChange: (value: string) => void;
}> = ({ values, value, onChange, trls }) => {
    return (
        <CustomSelect
            value={value}
            emptyPlaceholder={trls[TrlKeys.empty]}
            onChange={onChange}
            wrapperProps={customSelectWrapperProps}
        >
            {values.map((value) => (
                <CustomSelectOption key={value} value={value} data-qa={`tariff-field-optionsCount_${value}`}>
                    <Conversion
                        one={trls[TrlKeys.one]}
                        some={trls[TrlKeys.some]}
                        many={trls[TrlKeys.many]}
                        format={(trl) =>
                            format(trl, {
                                '{0}': value,
                            })
                        }
                        value={parseInt(value, 10)}
                        hasValue={false}
                    />
                </CustomSelectOption>
            ))}
        </CustomSelect>
    );
};

export default memo(translation(TariffFieldOptionsCount));
